import React from 'react';
import { RATES } from '../lib/pricing';

// The deal a technician agrees to before QPS Hub takes a cut of their money:
// the platform fee, and who carries a chargeback.
//
// One component, used in two places — the Get paid step of the application and
// the Payments tab for anyone who skipped it. The wording is what they agree
// to, so it lives in one file and cannot drift between the two screens.

const box = {
  background: 'var(--bg)',
  borderRadius: 'var(--radius-xs)',
  padding: '10px 12px',
  margin: '10px 0',
  fontSize: 12.5,
  lineHeight: 1.6,
};

export function PlatformFeeExplainer({ pct = RATES.platformPct }) {
  return (
    <>
      <div style={box}>
        <strong>How the price works.</strong> Your customer is charged your price, plus card processing, plus a {pct}% QPS
        Hub platform fee on the total they pay. On a $1,000 invoice the customer pays $1,148.45: you get $1,000.00,
        QPS Hub keeps $114.85 for running the platform, and $33.60 covers processing. The customer sees one total.
      </div>
      <div style={box}>
        <strong>If a customer disputes a payment.</strong> A customer is able to tell their bank to reverse a payment,
        which is called a chargeback. Nothing is taken from you while the bank decides, and we will fight it with the
        photos, estimates and messages you send us. If the bank sides with the customer, your share comes back out of
        your Stripe balance along with the fee the bank charges for the dispute.
      </div>
    </>
  );
}

// The one tick box. Both terms in one sentence, because a technician who reads
// only the thing next to the box should still know what they agreed to.
export function PlatformFeeAgreement({ checked, onChange, pct = RATES.platformPct, id = 'agree-platform-fee' }) {
  return (
    <label htmlFor={id} style={{ display: 'flex', gap: 8, alignItems: 'flex-start', fontSize: 13, marginBottom: 10 }}>
      <input id={id} type="checkbox" checked={checked} onChange={e => onChange(e.target.checked)} style={{ marginTop: 3 }} />
      <span>
        I have read and agree to the{' '}
        <a href="/vendor-terms" target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()}>
          QPS Hub Technician Agreement
        </a>
        : the {pct}% platform fee on payments my customers make online, and that a chargeback my customer wins is
        taken back from me, along with the bank's dispute fee.
      </span>
    </label>
  );
}

// What happens the moment they tap the button, so being sent off to another
// company's website is expected rather than alarming.
export function StripeHandoffNote() {
  return (
    <div style={{ fontSize: 11.5, color: 'var(--muted)', marginTop: 8, lineHeight: 1.55 }}>
      Next you go to Stripe, the company handling the payments. They ask for your ID and your bank account, and take
      about five minutes. Stripe holds those details, never this app.
    </div>
  );
}
